export default __webpack_public_path__ + "_/images/referrals/icon-e-58783f7b79c69e007da820557a94794a2cb757f3de92647b4f347b107647bf74.png";